// import useAuthStore from '@/store/authStore';
// import { removeAuthStorage } from '@/utils/localstorage';
// import logger from '@/utils/logger';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// const logout = () => {
//   const clearAuth = useAuthStore.getState().clearAuth;
//   removeAuthStorage();
//   clearAuth();
//   useAuthStore.persist.clearStorage();
//   window.location.href = '/'; // redirect to login
// };

// /* =======================
//    REQUEST INTERCEPTOR
// ======================= */
// axios.interceptors.request.use((config) => {
//   config.baseURL = import.meta.env.VITE_API_BASE_URL;

//   const isPublicApi = config.url?.includes('/auth/landing-page/preview');

//   if (!isPublicApi) {
//     const token = localStorage.getItem('access_token');
//     if (token) {
//       config.headers['authorization'] = `Bearer ${token}`;
//     }
//   } else {
//     // Ensure public API never sends auth header
//     delete config.headers?.authorization;
//   }

//   return config;
// });

// /* =======================
//    RESPONSE INTERCEPTOR
// ======================= */
// let retryCount = 0;
// const MAX_RETRIES = 3;
// let isLoggingOut = false;

// axios.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const isPublicApi = error.config?.url?.includes('/auth/landing-page/preview');

//     // 🚫 IMPORTANT: Do NOT refresh or logout for public APIs
//     if (isPublicApi) {
//       return Promise.reject(error);
//     }

//     const isUnauthorized = error.response?.status === 401;

//     if (isUnauthorized && retryCount < MAX_RETRIES) {
//       const refreshToken = localStorage.getItem('refresh_token');

//       if (refreshToken) {
//         try {
//           retryCount++;
//           const refreshResponse = await axios.post('auth/refresh-token', {
//             refreshToken,
//           });

//           const { token, refreshToken: newRefreshToken } = refreshResponse.data?.data || {};

//           if (token && newRefreshToken) {
//             localStorage.setItem('access_token', token);
//             localStorage.setItem('refresh_token', newRefreshToken);
//             error.config.headers.Authorization = `Bearer ${token}`;

//             return axios(error.config);
//           }
//         } catch (refreshError) {
//           logger.log(refreshError);
//           toast.error('Session expired. Please login again.');
//           retryCount = 0;
//           logout();
//         }
//       } else {
//         toast.error('No refresh token found. Please login again.');
//       }
//     }

//     if (isUnauthorized && !isLoggingOut) {
//       isLoggingOut = true;
//       logout();
//     }

//     const errorMessage = error.response?.data?.message || 'Something went wrong.';
//     toast.dismiss();
//     logger.error(errorMessage);

//     retryCount = 0;
//     return Promise.reject(error);
//   }
// );

// /* =======================
//    EXPORT API METHODS
// ======================= */
// const httpsCall = {
//   get: axios.get,
//   post: axios.post,
//   put: axios.put,
//   delete: axios.delete,
//   patch: axios.patch,
//   interceptors: axios.interceptors,
// };

// export default httpsCall;

import useAuthStore from '@/store/authStore';
import { clearAllFromLocalstorage, removeAuthStorage } from '@/utils/localstorage';
import logger from '@/utils/logger';
import axios from 'axios';
import { toast } from 'react-toastify';

const logout = () => {
  const clearAuth = useAuthStore.getState().clearAuth;
  removeAuthStorage();
  clearAuth();
  useAuthStore.persist.clearStorage();
  clearAllFromLocalstorage();
  // window.location.href = '/'; // redirect to login
};

axios.interceptors.request.use(async (config) => {
  config.baseURL = import.meta.env.VITE_API_BASE_URL;
  const token = localStorage.getItem('access_token') ?? '';
  if (token) {
    config.headers['authorization'] = `Bearer ${token}`;
  } else if (axios.defaults.headers.common['authorization']) {
    config.headers['authorization'] = axios.defaults.headers.common['authorization'];
  }
  return config;
});

let retryCount = 0;
const MAX_RETRIES = 3;

let isLoggingOut = false;

axios.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    const isUnauthorized = error.response?.status === 401;

    if (isUnauthorized && retryCount < MAX_RETRIES) {
      const getrefreshToken = localStorage.getItem('refresh_token');
      if (getrefreshToken) {
        try {
          retryCount++;
          const refreshResponse = await axios.post('auth/refresh-token', {
            refreshToken: getrefreshToken,
          });
          const { token, refreshToken } = refreshResponse.data?.data || {};
          if (token && refreshToken) {
            localStorage.setItem('access_token', token);
            localStorage.setItem('refresh_token', refreshToken);
            error.config.headers['Authorization'] = `Bearer ${token}`;

            return axios(error.config);
          }
        } catch (refreshError) {
          logger.log(refreshError);
          toast.error('Session expired. Please login again.');
          retryCount = 0;
          logout();
        }
      } else {
        toast.error('No refresh token found. Please login again.');
      }

      if (isUnauthorized && !isLoggingOut) {
        isLoggingOut = true;
        logout();
      }
    }

    if (isUnauthorized) {
      logout();
    }
    const errorMessage = error.response?.data?.message || 'Something went wrong.';
    toast.dismiss();
    logger.error(errorMessage);

    retryCount = 0;
    return Promise.reject(error);
  }
);

// Exporting axios call methods
const httpsCall = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch,
  interceptors: axios.interceptors,
};

export default httpsCall;
